module.exports = __webpack_public_path__ + "static/ojo-9d477eee422c31d98080789ee7c63d43.png";